import React from 'react';
import { Users, ChartBar, Check } from '@phosphor-icons/react';

export const AdminStatsCards = ({ stats }) => {
  const cards = [
    { label: 'Total Users', value: stats.total_users, icon: Users },
    { label: 'Total Cases', value: stats.total_cases, icon: ChartBar },
    { label: 'Documents', value: stats.total_documents, icon: ChartBar },
    { label: 'Analyzed', value: stats.total_analyzed, icon: Check },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {cards.map(s => (
        <div key={s.label} className="bg-white border border-[#E5E7EB] rounded-lg p-4" data-testid={`admin-stat-${s.label.toLowerCase().replace(/\s+/g, '-')}`}>
          <div className="flex items-center gap-2 mb-1">
            <s.icon size={16} className="text-[#002FA7]" />
            <span className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">{s.label}</span>
          </div>
          <p className="font-outfit text-2xl font-bold text-[#09090B]">{s.value}</p>
        </div>
      ))}
    </div>
  );
};
